import * as BusinessTypeIcons from "@repo/icons/react/business-types";
import type { SVGProps } from "react";
import {
  CdnBusinessTypeIcon,
  type CdnBusinessTypeIconVariant,
} from "./cdn-business-type-icon";

export function BusinessTypeIcon({
  iconName,
  variant,
  ...props
}: SVGProps<SVGSVGElement> & {
  iconName: string;
  variant?: CdnBusinessTypeIconVariant;
}): React.JSX.Element {
  const Component =
    BusinessTypeIcons[iconName as keyof typeof BusinessTypeIcons];
  return Component ? (
    <Component {...props} />
  ) : (
    <CdnBusinessTypeIcon iconName={iconName} variant={variant} {...props} />
  );
}
